// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ForgotPassWordModal_wrapper__DIQ9T","form":"ForgotPassWordModal_form__dzs2h","errorText":"ForgotPassWordModal_errorText__Ojme7"};